import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הפחד",
    opening: localizedGenderNode(
      [
      "היום אני לא נלחם/ת בפחד מהצלחה.",
      "אני רק מזהה: הוא כאן."
    ],
      [
      "היום אני לא נלחם/ת בפחד מהצלחה.",
      "אני רק מזהה: הוא כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הפחד הזה הכי חזק?",
      "מה התסריט שמופיע מיד?",
      "מה אני מרגיש/ה בגוף?"
    ],
      [
      "מתי הפחד הזה הכי חזק?",
      "מה התסריט שמופיע מיד?",
      "מה אני מרגיש/ה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד הוא חוויה, לא עובדה."
    ],
      [
      "פחד הוא חוויה, לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני רואה את הפחד\".",
      "נשימה אחת + \"אני רואה את הפחד\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שהפחד מתחיל.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב לרגע שהפחד מתחיל.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה רגע לפני שזה עולה?",
      "איפה אני כשזה מתחיל?",
      "מה אני מפחד/ת שיקרה?"
    ],
      [
      "מה קורה רגע לפני שזה עולה?",
      "איפה אני כשזה מתחיל?",
      "מה אני מפחד/ת שיקרה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מעט מרחב."
    ],
      [
      "ברגע הראשון יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשהפחד מתחיל.",
      "נשימה אחת כשהפחד מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "אותות הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה המתח יושב בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה המתח יושב בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד שמתחת להצלחה.",
      "אני נשאר/ת איתו רגע."
    ],
      [
      "היום אני נוגע/ת בפחד שמתחת להצלחה.",
      "אני נשאר/ת איתו רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת שיקרה אם אצליח?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ],
      [
      "ממה אני מפחד/ת שיקרה אם אצליח?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד רוצה הגנה, לא מלחמה."
    ],
      [
      "פחד רוצה הגנה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "לקרוא לפחד בשם בשקט.",
      "לקרוא לפחד בשם בשקט."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הקול שמבפנים",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול שמזהיר אותי.",
      "בלי להילחם בו."
    ],
      [
      "היום אני מקשיב/ה לקול שמזהיר אותי.",
      "בלי להילחם בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הקול הזה נשמע?",
      "מה הוא מנסה להגן עליו?",
      "מה הייתי רוצה לומר לו?"
    ],
      [
      "איך הקול הזה נשמע?",
      "מה הוא מנסה להגן עליו?",
      "מה הייתי רוצה לומר לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול הוא רק קול."
    ],
      [
      "קול הוא רק קול."
    ]
    ),
    action: localizedGenderNode(
      "לשים לב אליו בלי להאמין לו.",
      "לשים לב אליו בלי להאמין לו."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "הצורך בביטחון",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לפחד.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לפחד.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לי לבחור הצלחה בעדינות?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לי לבחור הצלחה בעדינות?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ביטחון קטן משנה את הטון."
    ],
      [
      "ביטחון קטן משנה את הטון."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של ביטחון.",
      "לכתוב מילה אחת של ביטחון."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "להניח רגע",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הפחד לרגע.",
      "רק רגע."
    ],
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הפחד לרגע.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ],
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להניח לרגע זו גם בחירה."
    ],
      [
      "להניח לרגע זו גם בחירה."
    ]
    ),
    action: localizedGenderNode(
      "רגע אחד בלי להילחם בפחד.",
      "רגע אחד בלי להילחם בפחד."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "שפה פנימית רכה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ],
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת אל עצמי כשאני מפחד/ת מהצלחה?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ],
      [
      "איך אני מדבר/ת אל עצמי כשאני מפחד/ת מהצלחה?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול רך מוריד לחץ."
    ],
      [
      "קול רך מוריד לחץ."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט הרך פעם אחת.",
      "לומר את המשפט הרך פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "רגע לפני צעד",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני צעד קדימה.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני צעד קדימה.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לעצור.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לעצור.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוצר אותי מלהצליח?",
      "מה יקרה אם אעשה צעד קטן?",
      "מה יכול לתמוך בי רגע אחד?"
    ],
      [
      "מה עוצר אותי מלהצליח?",
      "מה יקרה אם אעשה צעד קטן?",
      "מה יכול לתמוך בי רגע אחד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני צעד.",
      "נשימה אחת לפני צעד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "לחזור להווה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ],
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ההווה נותן לי קרקע."
    ],
      [
      "ההווה נותן לי קרקע."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "רגע לפני בחירה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני בחירה.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני בחירה.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לעצור.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לעצור.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני רוצה לבחור?",
      "מה מפחיד אותי בבחירה הזו?",
      "מה צעד קטן אפשרי לי?"
    ],
      [
      "מה אני רוצה לבחור?",
      "מה מפחיד אותי בבחירה הזו?",
      "מה צעד קטן אפשרי לי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בחירה קטנה היא תנועה."
    ],
      [
      "בחירה קטנה היא תנועה."
    ]
    ),
    action: localizedGenderNode(
      "לנסח בחירה אחת לעצמי.",
      "לנסח בחירה אחת לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן שמחזיר אותי לעצמי.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן שמחזיר אותי לעצמי.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן יכול לעזור לי לבחור הצלחה?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "איזה צעד קטן יכול לעזור לי לבחור הצלחה?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הפחד הזה?",
      "מה הסימן הראשון שהוא עולה?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על הפחד הזה?",
      "מה הסימן הראשון שהוא עולה?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const fearOfSuccessBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_of_success_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_of_success",
  category: "anxiety",
  journeyName: {
    he: "פחד מהצלחה",
    en: "Fear of success",
    es: "Miedo al exito",
  },
  days,
});

export default fearOfSuccessBlueprintHe;
